/**
 * Makes a DOM element sticky (position fixed) when the user scrolls
 * past it. Returns the StickyElement class/object.
 *
 * @module Sticky
 */
define(
    'utils/sticky',['jquery'], function ($) {
        'use strict';

        /**
         * StickyElement
         *
         * @class StickyElement
         */
        return (function () {
            var stickyClass,
                el,
                isSticky,
                _togglePlaceholderElement,
                placeholder,
                initialized = false,
                enabled = true;

            function StickyElement (element) {
                el = element;
            }

            /**
             * Initializes the sticky feature. It basically attaches an event listener
             * to the scroll event of html,body (both for compability reasons) and then
             * toggles the stickyness depending on how far the user has scrolled from the top
             *
             * @method init
             * @return {StickyElement} Returns itself, which allows you to chain a second call
             */
            StickyElement.prototype.init = function () {
                var offsetY = el.position().top,
                    _this = this,
                    scrollTop;

                $(document).on('scroll stickyInit', function (event) {
                    scrollTop = $(window).scrollTop();

                    if (scrollTop > offsetY && !isSticky) {
                        _this.setSticky(true);
                    } else if (scrollTop < offsetY && isSticky) {
                        _this.setSticky(false);
                    }
                });

                // Trigger sticky "check" on page load
                $(document).trigger('stickyInit');

                initialized = true;

                return this;
            };

            /**
             * Disable stickyness
             *
             * @method disable
             */
            StickyElement.prototype.disable = function () {
                enabled = false;
            };

            /**
             * Enable stickyness
             *
             * @method enable
             */
            StickyElement.prototype.enable = function () {
                enabled = true;
            };

            /**
             * Set a class that should be added to the given element when it becomes sticky
             *
             * @method setStickyClass
             * @param className
             * @returns {StickyElement}
             */
            StickyElement.prototype.setStickyClass = function (className) {
                stickyClass = className;

                return this;
            };

            /**
             * Toggles the placeholder element to prevent a "jump" when the given element becomes fixed.
             * This method is not accessible from outside this scope.
             *
             * @private
             * @method _togglePlaceholderElement
             * @param toggle
             */
            _togglePlaceholderElement = function (toggle) {
                if (toggle) {
                    var width = el.outerWidth(),
                        height = el.outerHeight();

                    placeholder = $('<div></div>');
                    placeholder.width(width);
                    placeholder.height(height);
                    el.after(placeholder);
                } else {
                    placeholder.remove();
                }
            };

            /**
             * Toggles the stickyness
             *
             * @method setSticky
             * @param toggle {Boolean} Either on or off, true/false
             * @return {void}
             */
            StickyElement.prototype.setSticky = function (toggle) {
                if (!enabled) {
                    return;
                }

                var height = el.outerHeight(),
                    offset = el.offset().top,
                    gonePast = $(window).scrollTop() - (height + offset);

                _togglePlaceholderElement(toggle);

                if (toggle) {
                    var transitionCss = {
                        'top': 0,
                        'position': 'fixed'
                    };

                    if (gonePast > 0) {
                        transitionCss = $.extend(transitionCss, {
                            'top': height * -1
                        });

                        el.css(transitionCss);

                        setTimeout(function () {
                            el.css({
                                'transition': '.3s top ease',
                                'top': 0
                            });
                        }, 300);
                    } else {
                        el.css(transitionCss);
                    }

                    if (stickyClass !== undefined) {
                        el.addClass(stickyClass);
                    }
                } else {
                    el.removeAttr('style');

                    if (stickyClass !== undefined) {
                        el.removeClass(stickyClass);
                    }
                }

                isSticky = toggle;
            };

            return StickyElement;
        })();
    }
);
